export default {
  toasts: {
    printing: 'Impression...',
    print_failed: "Échec de l'impression. Veuillez réessayer",
    orders: {
      print_one: 'Impression de {{count}} reçu : Commande <strong>#{{orderNumber}}</strong>...',
      print_other: 'Impression de {{count}} reçus : Commande <strong>#{{orderNumber}}</strong>...',
    },
  },
};
